import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  question: 'How is this different from hiring a marketing agency?',
  answer: 'Traditional agencies rely heavily on manual work, which means high costs and slow execution. We combine expert strategists with AI automation to deliver enterprise-level marketing at a fraction of the cost and 10x the speed. You get the best of both worlds: human creativity and AI efficiency.'
}, {
  question: 'Do I need to have AI expertise on my team?',
  answer: "Not at all! That's the whole point. We handle all the AI setup, training, and optimization. You just need to provide us with information about your business and goals. Our team of experts manages everything from strategy to execution."
}, {
  question: 'How quickly will I see results?',
  answer: 'Most clients see initial results within 30 days, with significant pipeline growth by month 3. The Pilot Sprint is designed to prove value in just 4 weeks. However, the best results come from sustained effort over 6-12 months as AI models learn and optimize.'
}, {
  question: 'What if the AI makes mistakes or sounds robotic?',
  answer: 'Our expert team trains and monitors all AI outputs to ensure they match your brand voice and quality standards. We use advanced prompt engineering and human oversight to prevent robotic or off-brand content. Every major campaign is reviewed by our strategists before launch.'
}, {
  question: 'Can I cancel or change my plan?',
  answer: 'Yes! We offer flexible month-to-month contracts after the initial setup period. You can upgrade, downgrade, or pause services with 30 days notice. We want you to stay because of results, not contracts.'
}, {
  question: 'What kind of ROI can I expect?',
  answer: 'Our clients typically see 3-5x ROI within 6 months. For example, a Growth plan client investing $205k/year usually breaks even with just 12 extra deals (assuming $30k ACV and 60% margin). Performance fees ensure we are aligned with your success.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="py-24 bg-gray-50" data-id="element-48">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-50">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-51">
            Frequently Asked
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-52">
              Questions
            </span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-53">
            Everything you need to know about working with SalesMax
          </p>
        </div>
        {/* FAQ Items */}
        <div className="space-y-4" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border-2 border-gray-200 overflow-hidden hover:border-blue-300 transition-all" data-id="element-55">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-56">
                <span className="font-semibold text-gray-900 text-lg pr-8" data-id="element-57">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-blue-600 flex-shrink-0" data-id="element-58" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-59" />}
              </button>
              {openIndex === index && <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-60">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
        {/* Bottom CTA */}
        <div className="mt-12 text-center" data-id="element-61">
          <p className="text-gray-600 mb-4" data-id="element-62">Still have questions?</p>
          <button onClick={() => window.open('https://calendly.com', '_blank')} className="text-blue-600 font-semibold hover:text-blue-700 transition-colors" data-id="element-63">
            Book a call to get answers →
          </button>
        </div>
      </div>
    </div>;
}